import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-granth-outstanding-brief',
  templateUrl: './granth-outstanding-brief.component.html',
  styleUrls: ['./granth-outstanding-brief.component.scss']
})
export class GranthOutstandingBriefComponent implements OnInit {

  startDate: any = '';
  endDate: any = '';

  repName: any[] = [];
  offRepName: any[] = [];
  booksellerName: any[] = [];

  reportType = '';
  currentDate = new Date();

  OutstandingB: any[] = [];

  totalInvAmount = 0;
  totalPaidAmount = 0;
  totalCrdtAmount = 0;
  totalUnpaidAmount = 0;

  constructor(
    private dialogRef: MatDialogRef<GranthOutstandingBriefComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {

    this.startDate = this.data.startDate;
    this.endDate = this.data.endDate;

    this.reportType = this.data.reportType;

    this.repName = this.data.repName || [];
    this.offRepName = this.data.officeRepWise || [];
    this.booksellerName = this.data.bookSellerWise || [];

    this.loadReport();
  }

  loadReport() {

    const req: any = {};

    if (this.startDate) {
      req.start_date = this.startDate;
    }

    if (this.endDate) {
      req.end_date = this.endDate;
    }

    if (this.repName.length) {
      req.rep_name = this.repName;
    }

    if (this.offRepName.length) {
      req.office_rep_name = this.offRepName;
    }

    if (this.booksellerName.length) {
      req.book_seller_name = this.booksellerName;
    }

    this.service.getBookOutstandinggranthBriefly(req).subscribe((res: any) => {

      this.OutstandingB = res || [];

      this.totalInvAmount = 0;
      this.totalPaidAmount = 0;
      this.totalCrdtAmount = 0;
      this.totalUnpaidAmount = 0;

      this.OutstandingB.forEach((office: any) => {

        office.inv_Total = 0;
        office.paid_Total = 0;
        office.crdt_Total = 0;
        office.bal_Total = 0;

        office.rep_data.forEach((rep: any) => {

          office.inv_Total += Number(rep.inv_amt_total) || 0;
          office.paid_Total += Number(rep.net_amt_total) || 0;
          office.crdt_Total += Number(rep.crdt_amt_total) || 0;
          office.bal_Total += Number(rep.unpaid_amt_total) || 0;

        });

        this.totalInvAmount += office.inv_Total;
        this.totalPaidAmount += office.paid_Total;
        this.totalCrdtAmount += office.crdt_Total;
        this.totalUnpaidAmount += office.bal_Total;

      });

      this.cdr.detectChanges();

    });

  }

  printPageA4() {

    const printContent = document.getElementById('print-section');

    if (!printContent) {
      return;
    }

    const win = window.open('', '', 'width=1200,height=800');

    win!.document.write(`
    <html>
      <head>
        <title>Book Outstanding Brief Report</title>

        <style>

        @page{
          size:A4 landscape;
          margin:8mm;
        }

        body{
          font-family:Arial;
          font-size:12px;
        }

        table{
          width:100%;
          border-collapse:collapse;
        }

        th,td{
          border:1px solid black;
          padding:5px;
        }

        thead{
          display:table-header-group;
        }

        tr{
          page-break-inside:avoid;
        }

        </style>

      </head>

      <body>

      ${printContent.innerHTML}

      </body>

    </html>
    `);

    win!.document.close();

    setTimeout(() => {
      win!.print();
      win!.close();
    }, 500);

  }

  exportExcel(fileName: string) {
    console.log(fileName);
    // Add XLSX export code here if required.
  }

  close() {
    this.dialogRef.close();
  }

}